var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { concat, equals, isEmpty, map, none, propEq, reject } from "ramda";
export function addGiftCardToList(giftCard, giftCards) {
    if (none(propEq("index", giftCard.index), giftCards)) {
        return concat([giftCard], giftCards);
    }
    return map(function (card) {
        if (equals(giftCard.index, card.index)) {
            return __assign({}, giftCard);
        }
        return card;
    }, giftCards);
}
export function removeGiftCardFromListByIndex(index, giftCards) {
    var withoutRemovedCard = reject(propEq("index", index), giftCards);
    return isEmpty(withoutRemovedCard)
        ? withoutRemovedCard
        : [
            __assign(__assign({}, withoutRemovedCard[0]), { index: 0 }),
        ];
}
